export function makeFactAddressItems(data) {
    const schedule = data?.schedule ?? {};
    const sectors = schedule?.sectors;

    return [
        {
            label: "Tipo",
            value: schedule?.placetype ?? "",
        },
        {
            label: "Local pré-cadastrado",
            value: schedule?.place ?? "",
        },
        {
            label: "Logradouro",
            value: schedule?.street ?? "",
        },
        {
            label: "Número",
            value: schedule?.number ?? "",
        },
        {
            label: "Bairro",
            value: schedule?.neighborhood ?? "",
        },
        {
            label: "Cruzamento",
            value: schedule?.crossroads ?? "",
        },
        {
            label: "Ponto de referência",
            value: schedule?.rencePoint ?? "",
        },
        {
            label: "Município",
            value: schedule?.city ?? "",
        },
        {
            label: "Setores",
            value: Array.isArray(sectors) ? sectors.join(", ") : (sectors ?? ""),
            className: "col-span-2",
        },
    ];
}
